// Свои строки Mini App (extra/<область>.json, в каждом все семь языков) делятся на два вида (HQ-667):
//  - строки оболочки и первого экрана (shell, matchCenter, match, menu) — в основном куске, на месте до первого кадра;
//  - строки экранов W2–W3 (вкладки и экраны сущностей) — отдельными кусками, грузятся вместе с ленивым экраном своей
//    области (src/i18n/lazyScreen.ts), до его первого рендера. Так строки нового экрана не растят первый экран (≤ 150 КБ).
// Новый файл extra — добавить в StringKey (i18n.ts) и сюда: в FIRST_SCREEN_AREAS, если без него оболочка или первый
// экран рисуют ключ, иначе в LAZY_AREAS (tests/shell/lazyStrings.test.tsx сверяет списки с папкой).
// В тестах tests/setup.ts подменяет этот модуль: все файлы — сразу, как раньше.
export type Table = Record<string, string>;
/** Файл extra: язык → строки. */
export type ExtraFile = Partial<Record<string, Table>>;

export const FIRST_SCREEN_AREAS = ['shell', 'matchCenter', 'match', 'menu'] as const;
export const LAZY_AREAS = ['leagues', 'tournament', 'worldCup', 'team', 'player', 'search', 'news', 'highlights', 'favorites',
  'notifications'] as const;
/** Область строк экрана W2–W3. */
export type StringArea = (typeof LAZY_AREAS)[number];

/** './extra/team.json' → 'team'. */
export const areaOf = (path: string) => path.replace(/^.*\//, '').replace(/\.json$/, '');
const byArea = <T>(files: Record<string, T>): Record<string, T> =>
  Object.fromEntries(Object.entries(files).map(([path, file]) => [areaOf(path), file]));

/** Строки оболочки и первого экрана: область → файл. */
export const firstScreenStrings: Record<string, ExtraFile> = byArea(import.meta.glob<ExtraFile>(
  './extra/{shell,matchCenter,match,menu}.json', { eager: true, import: 'default' }));

/** Строки экранов W2–W3: область → загрузчик отдельного куска. */
export const areaStrings: Record<string, () => Promise<ExtraFile>> = byArea(import.meta.glob<ExtraFile>(
  ['./extra/*.json', '!./extra/{shell,matchCenter,match,menu}.json'], { import: 'default' }));
